import React, { useState } from "react";
import { useTransition, animated } from "react-spring";

export const FirstAnswer = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const generalContractor = [
    { id: "Has General Contractor/Builder", title: "Yes" },
    {
      id: "Still Looking for General Contractor/Builder",
      title: "Not yet, still looking",
    },
    {
      id: "will not get a contractor/builder",
      title: "I will not be working with a general contractor/builder",
    },
  ];

  const checkForNextStep = () => {
    if (formData.generalContractor === "") {
      setError(true);
      console.log("error");
    }
    if (formData.generalContractor !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-start mt-24">
        {transition((style, item) =>
          item ? (
            <animated.div
              style={style}
              className="mx-auto flex flex-col justify-start"
            >
              <div className="flex justify-end py-4 pb-8">
                <button
                  className="bg-gray-light py-1 px-14 text-grey-eighty text-md transition-all w-58 cursor-pointer"
                  onClick={() => navigation.go(0)}
                >
                  Start Over
                </button>
              </div>
              <div className="text-center text-xl bg-gray-200 p-4 rounded">
                <p>
                  If you are making your first mortgage payment or haven't yet
                  received your Notice of Servicing Transfer letter, you can
                  make a payment through our payment portal:{" "}
                  <a
                    target="_blank"
                    className="text-blue-complimentary hover:text-blue-dark transition-all underline"
                    href="https://secure2.cpteller.com/portal/?op=RxAluX10MCkX"
                  >
                    Payment Portal
                  </a>
                </p>
                <p className="mt-4">
                  If you are unable to make a payment through the payment
                  portal, please contact our Loan Servicing Department directly
                  so they can advise who to make your payments to. You can email
                  them at{" "}
                  <a
                    href="mailto:loanservicing@onetrustintl.com"
                    className="text-blue-complimentary hover:text-blue-dark transition-all underline"
                  >
                    loanservicing@onetrustintl.com
                  </a>{""}.
                    In your email, please include your name, loan number, and
                    property address.
                </p>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
    </div>
  );
};
